import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../supabase';

const ResetPassword = () => {
  const navigate = useNavigate();

  // We'll track:
  // 1) Whether we've verified the token
  // 2) Whether we've successfully changed the password
  // 3) A message to show the user (status or error)
  const [isVerified, setIsVerified] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const type = params.get('type');
    const email = params.get('email');

    if (type === 'recovery' && token && email) {
      // Attempt to verify the OTP token with Supabase
      supabase.auth
        .verifyOtp({ email, token, type: 'recovery' })
        .then(({ data, error }) => {
          if (error) {
            setMessage(`Error verifying token: ${error.message}`);
            setIsVerified(false);
          } else {
            setIsVerified(true);
            setMessage('Please set your new password below.');
          }
        });
    } else {
      setMessage('Invalid reset link. Please check your email link again.');
      setIsVerified(false);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newPassword = e.target.elements.newPassword.value;
    if (!newPassword) return;

    setMessage('');
    try {
      // Update the user's password through Supabase
      const { error } = await supabase.auth.updateUser({ password: newPassword });
      if (error) throw error;

      // If all good:
      setIsSuccess(true);
      setMessage('Password updated successfully!');
    } catch (err) {
      setIsSuccess(false);
      setMessage(`Error: ${err.message}`);
    }
  };

  const handleGoToLogin = () => {
    navigate('/login');
  };

  return (
    <div style={{ marginTop: '1rem' }}>
      <h2>Reset Your Password</h2>

      {/* Status or error messages */}
      {message && (
        <p style={{ color: isSuccess ? 'green' : 'red' }}>
          {message}
        </p>
      )}

      {/* If we haven't verified the token, no form. Just show the error/info. */}
      {!isVerified && !isSuccess && (
        <p>Please check your link or try again.</p>
      )}

      {/* If verified but not yet successful, show the password form */}
      {isVerified && !isSuccess && (
        <form onSubmit={handleSubmit}>
          <label htmlFor="newPassword">New Password:</label>
          <br />
          <input
            type="password"
            id="newPassword"
            name="newPassword"
            required
            style={{ marginBottom: '0.5rem' }}
          />
          <br />
          <button type="submit">Update Password</button>
        </form>
      )}

      {/* If password update succeeded, hide the form & show a "Go to Login" button */}
      {isSuccess && (
        <button onClick={handleGoToLogin}>
          Go to Login
        </button>
      )}
    </div>
  );
};

export default ResetPassword;
